import {EtlConfig, Field, FieldPropOnChangeHandler} from '../types';

const debounce = require('debounce-promise');
import {Etl} from '../_services/Etl';
import {FlowFetchResponse} from '../_services/Flow';
import {applyFillMap} from './etl';

const loadAsyncOptionsCacheNap: any = {};
export const loadAsyncOptions = (field: Field, formState: any = null) => debounce(
    (inputValue: string) => {
        const minimumInputLength: number = field.etlConfig?.loadOptionsByDefault ? 0 : field.etlConfig.minimumInputLength || 3;
        const requestValueProperty = field.etlConfig?.requestValueProperty || 'q';
        const resultProperty = field.etlConfig.resultProperty || 'result';
        const resultValueProperty = field.etlConfig.resultValueProperty || 'name';
        const resultTextProperty = field.etlConfig.resultTextProperty || 'name';
        const resultDisplayProperty = field.etlConfig.resultDisplayProperty || resultTextProperty;
        const additionalRequestProperties = field.etlConfig?.additionalRequestProperties || [];
        const useCache = field.etlConfig?.useCache || false;
        const requestObject = {
            [requestValueProperty]: inputValue,
            ...additionalRequestProperties,
            // @ts-ignore
            // tslint:disable-next-line:no-eval
            ...(field.etlConfig?.additionalRequestPropertiesCallback ? eval(field.etlConfig.additionalRequestPropertiesCallback) : {})
        };

        if (inputValue.length < minimumInputLength) {
            console.log('inputValue.length < minimumLength', minimumInputLength);
            return;
        }

        let cacheKey = '';
        if (useCache) {
            try {
                cacheKey = field.id + JSON.stringify(requestObject);
                if (loadAsyncOptionsCacheNap.hasOwnProperty(cacheKey)) {
                    return Promise.resolve(loadAsyncOptionsCacheNap[cacheKey]);
                }
            } catch (e) {
                console.error('error reading from cache');
            }
        }

        return Etl.getInstance().process(field.etlConfig.pipeline, requestObject)
            .then((response: FlowFetchResponse) => {
                const options = response.json[resultProperty].map((item: any) => ({
                    value: item[resultValueProperty],
                    label: item[resultDisplayProperty],
                    text: item[resultTextProperty],
                    ...item
                }));

                if (useCache && cacheKey) {
                    loadAsyncOptionsCacheNap[cacheKey] = options;
                }

                return options;
            });
    },
    250
);

export const handleAsyncOnChange = (field: Field, onChange: FieldPropOnChangeHandler, onBlur: any = null) => (option: any) => {
    // if etlConfig.fillMap is defined, grab values from option and update state
    const updateAdditionalFields = field.etlConfig.fillMap ? applyFillMap(field.etlConfig.fillMap, option) : {};

    // after an async option is selected, apply the text property to the label
    // the value displayed during search can be different than the value displayed
    // in the dropdown
    if (option && typeof(option) === 'object') {
        option.label = option.text;
    }

    onChange && onChange(option, updateAdditionalFields);

    // React-Select on mobile fires onChange and onBlur simultaneously, onBlur depends on the value of the select having
    // been set. To fix, call onBlur with currently selected option after onChange
    setTimeout(() => {
        onBlur && onBlur({[field.name]: option, ...updateAdditionalFields});
    }, 2);

    // if option is null (i.e., dropdown was cleared), no need to do Etl calls
    if (!(option && typeof(option) === 'object')) {
        return;
    }

    // if the mapping has an onSelect mapping, apply that here....
    // onChange will get called a second time after the promise resolves
    if (field?.etlConfig?.onSelect) {
        const onSelect = Array.isArray(field.etlConfig.onSelect) ? field.etlConfig.onSelect : [field.etlConfig.onSelect];

        onSelect.forEach((onSelectConfig: EtlConfig) => {
            if (onSelectConfig.pipeline) {
                console.log('processing', onSelectConfig);
                const etlConfig = onSelectConfig;
                const resultProperty = etlConfig.resultProperty || 'result';
                const requestObject = {
                    [etlConfig.requestValueProperty]: option.value,
                    ...etlConfig.additionalRequestProperties,
                    // tslint:disable-next-line:no-eval
                    ...(etlConfig?.additionalRequestPropertiesCallback ? eval(etlConfig.additionalRequestPropertiesCallback) : {})
                };

                Etl.getInstance().process(etlConfig.pipeline, requestObject)
                    .then((response) => {
                        if (response.ok) {
                            let result: object | object[] = response.json[resultProperty];
                            if (result instanceof Array) {
                                result = result.length > 0 ? result[0] : {};
                            }
                            const stateUpdates = applyFillMap(etlConfig.fillMap, result);
                            onChange && onChange(option, stateUpdates);
                        }
                    })
                    .catch((error: any) => {
                        console.log(error);
                    });
            }
        });
    }
};

export const handleEmailLookup = debounce(
    Etl.getInstance().employeeAutocompleter,
    250
);